export interface RevisionOption {
  revision_id: number | string;
  name?: string;
  [key: string]: unknown;
}

// The picker has its own endpoint, so renames must be mirrored into its list.
export const applyRevisionRename = <T extends RevisionOption>(
  list: T[],
  revisionId: number,
  title: string,
): T[] =>
  list.map((rev) =>
    Number(rev.revision_id) === revisionId ? { ...rev, name: title } : rev,
  );

// The picker's label is held separately from the list it was chosen from.
export const renamedSelectionLabel = (
  currentLabel: string,
  selectedRevisionId: number | undefined,
  revisionId: number,
  title: string,
): string => (selectedRevisionId === revisionId ? title : currentLabel);
